module.exports = __webpack_public_path__ + "static/media/ct-20.8523166d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/ct-20.png
// module id = 87
// module chunks = 0